interface AlertBadgeProps {
  severity: string
}

const COLORS: Record<string, { bg: string; text: string }> = {
  critical: { bg: '#fef2f2', text: '#dc2626' },
  warning: { bg: '#fffbeb', text: '#d97706' },
  info: { bg: '#eff6ff', text: '#2563eb' },
}

export function AlertBadge({ severity }: AlertBadgeProps) {
  const colors = COLORS[severity] || COLORS.info
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 8px',
        borderRadius: '9999px',
        fontSize: '11px',
        fontWeight: 600,
        fontFamily: 'var(--sans)',
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        background: colors.bg,
        color: colors.text,
      }}
    >
      {severity}
    </span>
  )
}
